import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import Datepicker from 'react-datepicker';
import { orderBy } from 'lodash';

import OrderOfPlayGrid from './OrderOfPlayGrid';

const _ = { orderBy };

const OrderOfPlay = (props) => {
    const { events, auth, maxMatchDate, onPrintPage, ...restProps } = props;
    const { locations, orderOfPlay, playersDict, teamsDict } = events.currentEvent;
    const event = events.currentEvent.data;
    const { timeZone, eventStartUtc, eventEndUtc } = event.eventSchedule;
    const defaultDate = moment().utc().isBefore(eventStartUtc) || moment().utc().isAfter(eventEndUtc) ? moment(eventStartUtc).tz(timeZone.value) : moment().tz(timeZone.value);
    const [date, setDate] = useState(moment(defaultDate));
    const [facilityList, setFacilityList] = useState([]);
    const [facilityId, setFacilityId] = useState('');

    const history = useHistory();
    useEffect(() => {
        console.log('rerender');
        if (locations && locations.length && orderOfPlay) {
            let fList = [];
            locations.forEach(loc => {
                if (loc.facilities) {
                    loc.facilities.forEach(fac => {
                        if (orderOfPlay.some(matchFromOop => matchFromOop.facilityId === fac.id)) {
                            fList.push({
                                name: `${fac.name}`,
                                id: fac.id,
                            });
                        }
                    });
                }
            });
            fList = _.orderBy(fList, [f => f.name?.toLowerCase()]);
            setFacilityList(fList);
            setFacilityId(fList[0]?.id || '');
        }
    }, [locations, orderOfPlay]);

    const printSchedule = () => {
        if (onPrintPage) {
            window.print();
        } else {
            history.push(`/order-of-play/print`);
        }
    };

    const handleDateChange = (value) => {
        console.log('Date Value', value);
        setDate(value);
    };

    const handleFacilityChange = (e) => {
        setFacilityId(e.target.value);
    };

    if (locations !== null && events.currentEvent.data.id) {
        return (
            <>
                <div className="row mt16">
                    <div className="col-md-8 d-flex">
                        <div className="form-inline">
                            <div className={`form-group form-group-inline`}>
                                <div className="input-wrapper mr8">
                                    <Datepicker
                                        className="form-control form-control-sm"
                                        selected={date}
                                        onChange={handleDateChange}
                                        minDate={moment.utc(eventStartUtc)}
                                        maxDate={moment.utc(eventEndUtc)}
                                    />
                                </div>
                                <div className="input-wrapper mr8">
                                    <select
                                        className="form-control form-control-sm"
                                        value={facilityId}
                                        onChange={handleFacilityChange}
                                    >
                                        <option>Choose facilities...</option>
                                        {facilityList.map((fac) => (
                                            <option value={fac.id}>{fac.name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 d-none d-md-flex aic jce">
                        {auth?.user && (
                            <button
                                type="button"
                                className="btn btn-small btn-default float-right no-print"
                                onClick={printSchedule}
                            >
                                <i className="fas fa-print" /> Print
                            </button>
                        )}
                    </div>
                </div>
                <div className={`bg-transparent main-content`}>
                    <OrderOfPlayGrid
                        draws={event?.draws}
                        playersDict={playersDict}
                        orderOfPlay={orderOfPlay}
                        eventOfficials={events.drawOfficials}
                        locations={locations}
                        facilityId={facilityId}
                        timeZone={timeZone}
                        date={date}
                        teamsDict={teamsDict}
                        {...restProps}
                    />
                </div>
            </>
        );
    }
    return null;
};

function mapStateToProps({ auth, events, coreUI }) {
    return { auth, events, coreUI };
}

export default connect(mapStateToProps, null)(OrderOfPlay);
